import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { canReplayAgentHubBookingOnboarding } from './canStartAgentHubBookingOnboarding'
import useAgentHubBookingOnboarding from './useAgentHubBookingOnboarding'

function useAgentHubBookingOnboardingNeedHelp() {
  const intl = useIntl()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const isSpoofed = useAppSelector(state => state.auth.account.isSpoofed)
  const canReplay = canReplayAgentHubBookingOnboarding({
    isAgentHubEnabled,
    isLoggedIn,
    isSpoofed,
  })
  const label = intl.formatMessage({
    id: 'xx5C1UWMurVReTA_4jiX',
    defaultMessage: 'Need help?',
  })
  const { start } = useAgentHubBookingOnboarding()

  return {
    canReplay,
    label,
    start,
  }
}

export default useAgentHubBookingOnboardingNeedHelp
